export default "__VITE_ASSET__Cn1cHq5B__"